import { configureStore } from '@reduxjs/toolkit';
import startReducer from '../features/StartSlice';
import endReducer from '../features/EndSlice';

export const store = configureStore({
  reducer: {
    start : startReducer,
    end: endReducer,
  },
});
